import { Modal, TextInput } from '@mantine/core';
import { ReactComponent as LeftArrowIcon } from 'assets/icons/orangeLeftArrow.svg';
import PrimaryButton from 'components/primaryButton';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';

import useUpdateNameOfFileOrFolder from '../../hooks/useUpdateNameofFileorFolder';

const ReNameFolderOrFile = ({
  isDirectory,
  path,
  name,
  renameModal,
  setRenameModal,
}) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
    setValue,
  } = useForm({ mode: 'onchange ' });

  const defaultValue = {
    name: '',
  };

  const closeModal = () => {
    setRenameModal(false);
    reset({ defaultValue });
  };

  const extension = name.split('.').pop();
  const nameoffolderorFile = name.split('.');

  useEffect(() => {
    setValue(
      'name',
      nameoffolderorFile?.length === 1
        ? nameoffolderorFile[0]
        : nameoffolderorFile.slice(0, -1).join('.', 0, -1)
    );
    // eslint-disable-next-line
  }, [name]);

  const customTitle = () => {
    return (
      <div className='relative flex justify-center items-center text-xl mx-4 my-4'>
        <LeftArrowIcon
          onClick={closeModal}
          className='w-4 absolute left-0 cursor-pointer'
        />
        {/* <p>{folderId ? 'Update folder' : 'Create folder'}</p> */}
        <p>Rename {isDirectory ? 'Folder' : 'File'}</p>
      </div>
    );
  };

  const getErrorMessage = (name) => {
    return (
      errors[name] && (
        <p className=' text-sm font-semibold text-red-500'>
          {errors[name]?.message}
        </p>
      )
    );
  };

  const updateNameMutation = useUpdateNameOfFileOrFolder(closeModal);

  const AddnewsubFolder = (data) => {
    const newPathQ = isDirectory ? data?.name : `${data?.name}.${extension}`;

    const oldPath = `${path}/${name}`;
    const newPath = `${path}/${newPathQ}`;

    updateNameMutation.mutate({
      old_path: oldPath,
      new_path: newPath,
    });
  };
  return (
    <Modal
      opened={renameModal}
      onClose={closeModal}
      title={customTitle()}
      withCloseButton={false}
      overlayColor={'#F8F7F799'}
      overlayBlur={20}
      overlayOpacity={0.5}
      centered
      size={600}
      radius='md'
      overflow='inside'
      transitionDuration={100}
      classNames={{
        title: 'w-full text-primary font-semibold text-18',
        modal: 'pl-10',
        body: 'scroller -mr-4 pr-2',
      }}
    >
      <form className='px-4' onSubmit={handleSubmit(AddnewsubFolder)}>
        <div>
          <Controller
            control={control}
            name='name'
            rules={{
              required: 'Required',
              pattern: {
                value: /^[ A-Za-z0-9_@.#&+(-)]*$/,
                message: 'Input must be an alphabets or integers',
              },
            }}
            defaultValue={nameoffolderorFile[0]}
            render={({ field }) => (
              <TextInput
                {...field}
                label={`Name of the ${isDirectory ? 'Folder' : 'File'}`}
                defaultValue={nameoffolderorFile[0]}
                size='md'
                classNames={{
                  input: 'border-primary',
                  label: 'text-neutralsGrey text-sm',
                }}
              />
            )}
          />
          {getErrorMessage('name')}
        </div>
        <div className='flex justify-center items-center my-5 mt-10'>
          <button>
            <PrimaryButton>Save</PrimaryButton>
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default ReNameFolderOrFile;
